
const centralListeners = {};

export function dispatchCentral(eventName, opts = {}) {
    const listeners = centralListeners[eventName];
    if (!listeners || listeners.length === 0) {
        console.warn('no listeners for event', eventName)
        return
    }
    const evt = Object.assign({ type: eventName, timestamp: Date.now() }, opts)
    listeners.forEach((fn) => fn(evt))
}

export function listenCentral(eventName, handler) {
    centralListeners[eventName] = (centralListeners[eventName] || []).concat([handler])
}

function listenAll1(eventName, elements, handler) {
    for (var i = -1, len = elements.length; ++i < len;) {
        elements[i].addEventListener(eventName, handler);
    }
}

export function listenAll(eventName, elements, handler) {
    eventName.split(' ').forEach(eName => listenAll1(eName, elements, handler))
}
